/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OperationalIssueResponseResult
 */
export interface OperationalIssueResponseResult {
  /**
   * Whether the response answered the question. False means it was
   * recorded and we now owe the carrier a reply, but the task stays open.
   *
   * @type {boolean}
   * @memberof OperationalIssueResponseResult
   */
  taskClosed: boolean;
  /**
   * When taskClosed is false, what is still needed — shown to the carrier
   * so they aren't left guessing why the issue is still on their list.
   *
   * @type {string}
   * @memberof OperationalIssueResponseResult
   */
  outstanding?: string;
}

/**
 * Check if a given object implements the OperationalIssueResponseResult interface.
 */
export function instanceOfOperationalIssueResponseResult(
  value: object,
): value is OperationalIssueResponseResult {
  if (!("taskClosed" in value) || value["taskClosed"] === undefined)
    return false;
  return true;
}

export function OperationalIssueResponseResultFromJSON(
  json: any,
): OperationalIssueResponseResult {
  return OperationalIssueResponseResultFromJSONTyped(json, false);
}

export function OperationalIssueResponseResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OperationalIssueResponseResult {
  if (json == null) {
    return json;
  }
  return {
    taskClosed: json["taskClosed"],
    outstanding: json["outstanding"] == null ? undefined : json["outstanding"],
  };
}

export function OperationalIssueResponseResultToJSON(
  json: any,
): OperationalIssueResponseResult {
  return OperationalIssueResponseResultToJSONTyped(json, false);
}

export function OperationalIssueResponseResultToJSONTyped(
  value?: OperationalIssueResponseResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    taskClosed: value["taskClosed"],
    outstanding: value["outstanding"],
  };
}
